export function initReadingProgress() {
    const article = document.querySelector('[data-page="article"]');
    if (!article) return;

    const root = document.documentElement;
    const percentLabel = document.querySelector('[data-progress]');

    let ticking = false;

    const update = () => {
        const scrollTop = window.scrollY;
        const max = Math.max(1, root.scrollHeight - window.innerHeight);
        const progress = Math.min(1, Math.max(0, scrollTop / max));
        root.style.setProperty('--progress', progress.toFixed(4));
        if (percentLabel) {
            percentLabel.textContent = `${Math.round(progress * 100)}% read`;
        }
        ticking = false;
    };

    const onScroll = () => {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
}
